import PlainText from '@components/plain-text';
import React from 'react';
import * as styles from './RatingRowPosition.scss';

const RatingRowPosition = ({ position }) => (
  <PlainText
    className={styles.ratingRowPosition}
    color="neutral-tone-4"
  >
    {position}
  </PlainText>
);

export default RatingRowPosition;
